<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <modal-form-classic
    :action="`/bills/${billId}/reject`"
    :header-text="$t('Decline bill')"
    :action-button-text="$t('Decline')"
    :saving-text="$t('Declining') + '...'"
    data-test="decline-bill-modal"
    @validation-result="onValidationResult"
  >
    <template #trigger>
      <slot />
    </template>
    <input name="bill_updated_at" :value="billUpdatedAt" type="hidden" />
    <input v-if="redirectUri" :value="redirectUri" name="redirectUri" type="hidden" />
    <p class="m-t-15 m-b-15">
      {{
        $t(
          'You need to add an explanation for why you are declining this bill to give the hire full transparency.',
        )
      }}
    </p>
    <textarea
      id="textarea-message"
      :placeholder="$t('Type your message.')"
      required
      name="message"
      class="form-control"
      rows="3"
      data-validate="true"
      data-validation-min-length="1"
      data-test="decline-bill-message"
    ></textarea>
    <span v-if="validationErrors.length > 0" id="company-error" class="help-block error-help-block">
      {{ $t('Adding a short message is required to decline this bill') }}
    </span>
    <WdsAlert v-if="hasSourcePaymentRequest" info class="m-t-15" data-test="decline-bill-supplier-notice">
      {{ $t('This explanation will be shared with the supplier.') }}
    </WdsAlert>
  </modal-form-classic>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: { WdsAlert },
  props: {
    billId: { type: [Number, String], required: true },
    billUpdatedAt: { type: String, required: true },
    redirectUri: { type: String, default: '' },
    hasSourcePaymentRequest: { type: Boolean, default: false },
  },
  data() {
    return {
      validationErrors: [],
    }
  },
  methods: {
    onValidationResult(data) {
      this.validationErrors = data
    },
  },
}
</script>
